export default __webpack_public_path__ + "static/media/uni_aereo.879da953.jpg";